module.exports = __webpack_public_path__ + "static/media/logo1.0bbc4405.png";